import styled from 'styled-components';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';

const StyledBanner = styled.section`
  position: fixed;
  top: 64px;
  width: 100%;
  color: ${() => theme.color.black};
  background-color: ${() => theme.color.white};
  border-radius: 0 0 10px 10px;
  padding: 10px 0 33px;
  z-index: 10;
  overflow: hidden;
`;

const StyledTopContent = styled.div`
  margin-bottom: 11px;
`;

const StyledBottomContent = styled.div`
  transition: 0.2s;
`;

const StyledButton = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 33px;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 10px;
    width: 128px;
    height: 8px;
    transform: translateX(-50%);
    border-radius: 100px;
    background-color: ${() => theme.color.gray100};
  }
`;

const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;

  & > div {
    margin: 0;
  }
`;

const StyledDescription = styled.p`
  ${typeStyle['font-12']};
`;

const StyledLogo = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
  margin-right: 9px;
`;

const StyledImageContainer = styled.div`
  position: relative;
  padding-top: 46.44%;
  margin-bottom: 11px;
`;

const StyledImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

const StyledLabel = styled.span`
  font-size: 1.2rem;
  line-height: 1.5;
  text-transform: uppercase;
`;

export {
  StyledBanner,
  StyledTopContent,
  StyledBottomContent,
  StyledButton,
  StyledTitle,
  StyledDescription,
  StyledLogo,
  StyledImageContainer,
  StyledImage,
  StyledLabel,
};
